// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Panel":"bck_a bhb_cw bhb_jx bhb_jo bhb_rh bhb_vf"};